import { AbstractControl, FormGroup, UntypedFormGroup } from '@angular/forms';

export function formGroupCheckboxesSelectionRequired(control: AbstractControl) {
    if (control instanceof UntypedFormGroup || control instanceof FormGroup) {
        const controlValueKeys = Object.keys(control.value);

        for (let i = 0; i < controlValueKeys.length; i++) {
            if (control.value[controlValueKeys[i]] === true) {
                return null;
            }
        }

        return {
            checkboxGroupAtLeastOneSelectionReq: true,
        };
    }

    return null;
}
